import { makeStyles } from '@fluentui/react-components';

const paginationButtonBase = {
    width: "125px !important",
    height: "42px !important",
    lineHeight: "42px",
    fontSize: "14px !important",
    fontFamily: "KantarBrownWeb-Regular !important",
    border: "1px solid black !important",
    backgroundColor: "rgb(242 241 238) !important",
    color: "black !important",
    cursor: "pointer",
    display: "flex !important",
    alignItems: "center !important",
    paddingTop: "2px !important",
    "&:hover": {
        backgroundColor: "#e0e0e0 !important",
        color: "black !important",
    },
    "&:active": {
        backgroundColor: "rgb(242 241 238) !important",
        color: "black !important",
    },
    "&:focus": {
        backgroundColor: "rgb(242 241 238) !important",
        color: "black !important",
    },
    "&:disabled": {
        backgroundColor: "rgb(242 241 238) !important",
        color: "black !important",
        cursor: "not-allowed",
    },
    "& *::after, & *::before, & span *::after": {
        content: "none !important",
        display: "none !important",
        border: "none !important",
        textDecoration: "none !important",
    },
    "& span": {
        width: "20px",
        height: "20px",
        display: "flex !important"
    },
    "& svg": {
        width: "20px",
        height: "20px",
        margin: "0 !important",
    }
};

export const useStyles = makeStyles({
    paginationControls: {
        display: "flex",
        justifyContent: "left",
        alignItems: "center",
        marginTop: "20px",
        marginBottom: "20px"
    },

    leftPaginationButton: {
        ...paginationButtonBase,
        justifyContent: "flex-start !important",
        "& span": {
            marginRight: "8px",
            marginBottom: "3px",
            display: "flex !important"
        }
    },

    rightPaginationButton: {
        ...paginationButtonBase,
        justifyContent: "flex-end !important",
        "& span": {
            marginLeft: "8px",
            marginBottom: "3px",
            display: "flex !important",
            flexBasis: "27px"
        }
    },

    pageInfo: {
        fontFamily: "KantarBrownWeb-Regular !important",
        padding: "0 20px"
    }
});
